// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.seller-onboarding-todos {
    --sot-accent: var(--color-link);
    --sot-border: var(--color-border-soft);
    background:
        radial-gradient(circle at 100% 0, color-mix(in srgb, var(--sot-accent) 12%, transparent),
        transparent 24rem),
        var(--color-surface);
    border: 1px solid var(--sot-border);
    overflow: visible;
}

.seller-onboarding-todos > .content {
    margin-top: 0;
}

.seller-onboarding-todos__intro {
    align-items: center;
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    margin-bottom: 1.25rem;
}

.seller-onboarding-todos__intro p {
    margin: 0;
}

.seller-onboarding-todos__eyebrow {
    color: var(--sot-accent);
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.seller-onboarding-todos__progress {
    background: var(--color-surface-soft);
    border: 1px solid var(--sot-border);
    border-radius: 12px;
    margin-bottom: 1rem;
    padding: 0.8rem 1rem;
}

.seller-onboarding-todos__progress-copy {
    align-items: center;
    display: flex;
    font-size: 0.82rem;
    justify-content: space-between;
    margin-bottom: 0.55rem;
}

.seller-onboarding-todos__progress-copy span {
    color: color-mix(in srgb, var(--color-text) 68%, transparent);
}

.seller-onboarding-todos__progress-track {
    background: color-mix(in srgb, var(--color-border) 60%, transparent);
    border-radius: 999px;
    height: 7px;
    overflow: hidden;
}

.seller-onboarding-todos__progress-track span {
    background: var(--sot-accent);
    border-radius: inherit;
    display: block;
    height: 100%;
    transition: width 180ms ease;
}

.seller-onboarding-todos__complete {
    align-items: center;
    background: var(--color-success-bg);
    border: 1px solid var(--color-success-border);
    border-radius: 10px;
    color: var(--color-success-text);
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
    padding: 0.75rem 1rem;
}

.seller-onboarding-todos__list {
    border: 1px solid var(--sot-border);
    border-radius: 14px;
    list-style: none;
    margin: 0;
    overflow: hidden;
    padding: 0;
}

.seller-onboarding-todo {
    align-items: center;
    background: var(--color-surface);
    display: grid;
    gap: 0.9rem;
    grid-template-columns: auto minmax(0, 1fr) auto;
    padding: 1rem;
}

.seller-onboarding-todo + .seller-onboarding-todo {
    border-top: 1px solid var(--sot-border);
}

.seller-onboarding-todo.is-done {
    background: color-mix(in srgb, var(--color-success-bg) 28%, var(--color-surface));
}

.seller-onboarding-todo__status {
    color: color-mix(in srgb, var(--color-text) 42%, transparent);
    font-size: 1.25rem;
}

.seller-onboarding-todo.is-done .seller-onboarding-todo__status {
    color: var(--color-success-text);
}

.seller-onboarding-todo__title-row {
    align-items: center;
    display: flex;
    gap: 0.4rem;
}

.seller-onboarding-todo__body p {
    color: color-mix(in srgb, var(--color-text) 68%, transparent);
    font-size: 0.82rem;
    line-height: 1.4;
    margin: 0.2rem 0 0;
}

.seller-onboarding-todo__action {
    align-items: center;
    display: inline-flex;
    font-size: 0.8rem;
    font-weight: 700;
    gap: 0.45rem;
    white-space: nowrap;
}

.seller-onboarding-todo__actions {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
}

.seller-onboarding-todo__hide {
    align-items: center;
    appearance: none;
    background: none;
    border: 0;
    color: color-mix(in srgb, var(--color-text) 46%, transparent);
    cursor: pointer;
    display: inline-flex;
    font: inherit;
    font-size: 0.7rem;
    gap: 0.3rem;
    padding: 0.15rem 0;
}

.seller-onboarding-todo__hide:hover,
.seller-onboarding-todo__hide:focus-visible {
    color: var(--color-text);
}

.seller-onboarding-todos__state {
    align-items: center;
    display: flex;
    gap: 0.6rem;
    margin: 0;
    padding: 1rem 0;
}

.seller-onboarding-todos__error {
    align-items: flex-start;
    flex-direction: column;
}

.seller-onboarding-todos__error p {
    color: var(--color-danger-text);
    margin: 0;
}

.seller-onboarding-todos__error button {
    background: var(--color-accent);
    border: 0;
    color: #fff;
    cursor: pointer;
    font: inherit;
    font-weight: 700;
    padding: 0.6rem 0.9rem;
}

@media (max-width: 650px) {
    .seller-onboarding-todos__intro {
        align-items: flex-start;
        flex-direction: column;
    }

    .seller-onboarding-todo {
        align-items: start;
        grid-template-columns: auto minmax(0, 1fr);
    }

    .seller-onboarding-todo__actions {
        align-items: flex-start;
        grid-column: 2;
    }
}

@media (prefers-reduced-motion: reduce) {
    .seller-onboarding-todos__progress-track span {
        transition: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/SellerOnboardingTodos.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,sCAAsC;IACtC;;;4BAGwB;IACxB,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,mCAAmC;IACnC,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,oEAAoE;IACpE,oBAAoB;IACpB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,6CAA6C;IAC7C,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,WAAW;IACX,+CAA+C;IAC/C,aAAa;AACjB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,iFAAiF;AACrF;;AAEA;IACI,6DAA6D;IAC7D,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,6DAA6D;IAC7D,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,6DAA6D;IAC7D,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,SAAS;IACT,WAAW;IACX,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,0CAA0C;IAC9C;;IAEA;QACI,uBAAuB;QACvB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".seller-onboarding-todos {\n    --sot-accent: var(--color-link);\n    --sot-border: var(--color-border-soft);\n    background:\n        radial-gradient(circle at 100% 0, color-mix(in srgb, var(--sot-accent) 12%, transparent),\n        transparent 24rem),\n        var(--color-surface);\n    border: 1px solid var(--sot-border);\n    overflow: visible;\n}\n\n.seller-onboarding-todos > .content {\n    margin-top: 0;\n}\n\n.seller-onboarding-todos__intro {\n    align-items: center;\n    display: flex;\n    gap: 1rem;\n    justify-content: space-between;\n    margin-bottom: 1.25rem;\n}\n\n.seller-onboarding-todos__intro p {\n    margin: 0;\n}\n\n.seller-onboarding-todos__eyebrow {\n    color: var(--sot-accent);\n    font-size: 0.72rem;\n    font-weight: 800;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n}\n\n.seller-onboarding-todos__progress {\n    background: var(--color-surface-soft);\n    border: 1px solid var(--sot-border);\n    border-radius: 12px;\n    margin-bottom: 1rem;\n    padding: 0.8rem 1rem;\n}\n\n.seller-onboarding-todos__progress-copy {\n    align-items: center;\n    display: flex;\n    font-size: 0.82rem;\n    justify-content: space-between;\n    margin-bottom: 0.55rem;\n}\n\n.seller-onboarding-todos__progress-copy span {\n    color: color-mix(in srgb, var(--color-text) 68%, transparent);\n}\n\n.seller-onboarding-todos__progress-track {\n    background: color-mix(in srgb, var(--color-border) 60%, transparent);\n    border-radius: 999px;\n    height: 7px;\n    overflow: hidden;\n}\n\n.seller-onboarding-todos__progress-track span {\n    background: var(--sot-accent);\n    border-radius: inherit;\n    display: block;\n    height: 100%;\n    transition: width 180ms ease;\n}\n\n.seller-onboarding-todos__complete {\n    align-items: center;\n    background: var(--color-success-bg);\n    border: 1px solid var(--color-success-border);\n    border-radius: 10px;\n    color: var(--color-success-text);\n    display: flex;\n    gap: 0.5rem;\n    margin-bottom: 1rem;\n    padding: 0.75rem 1rem;\n}\n\n.seller-onboarding-todos__list {\n    border: 1px solid var(--sot-border);\n    border-radius: 14px;\n    list-style: none;\n    margin: 0;\n    overflow: hidden;\n    padding: 0;\n}\n\n.seller-onboarding-todo {\n    align-items: center;\n    background: var(--color-surface);\n    display: grid;\n    gap: 0.9rem;\n    grid-template-columns: auto minmax(0, 1fr) auto;\n    padding: 1rem;\n}\n\n.seller-onboarding-todo + .seller-onboarding-todo {\n    border-top: 1px solid var(--sot-border);\n}\n\n.seller-onboarding-todo.is-done {\n    background: color-mix(in srgb, var(--color-success-bg) 28%, var(--color-surface));\n}\n\n.seller-onboarding-todo__status {\n    color: color-mix(in srgb, var(--color-text) 42%, transparent);\n    font-size: 1.25rem;\n}\n\n.seller-onboarding-todo.is-done .seller-onboarding-todo__status {\n    color: var(--color-success-text);\n}\n\n.seller-onboarding-todo__title-row {\n    align-items: center;\n    display: flex;\n    gap: 0.4rem;\n}\n\n.seller-onboarding-todo__body p {\n    color: color-mix(in srgb, var(--color-text) 68%, transparent);\n    font-size: 0.82rem;\n    line-height: 1.4;\n    margin: 0.2rem 0 0;\n}\n\n.seller-onboarding-todo__action {\n    align-items: center;\n    display: inline-flex;\n    font-size: 0.8rem;\n    font-weight: 700;\n    gap: 0.45rem;\n    white-space: nowrap;\n}\n\n.seller-onboarding-todo__actions {\n    align-items: flex-end;\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n}\n\n.seller-onboarding-todo__hide {\n    align-items: center;\n    appearance: none;\n    background: none;\n    border: 0;\n    color: color-mix(in srgb, var(--color-text) 46%, transparent);\n    cursor: pointer;\n    display: inline-flex;\n    font: inherit;\n    font-size: 0.7rem;\n    gap: 0.3rem;\n    padding: 0.15rem 0;\n}\n\n.seller-onboarding-todo__hide:hover,\n.seller-onboarding-todo__hide:focus-visible {\n    color: var(--color-text);\n}\n\n.seller-onboarding-todos__state {\n    align-items: center;\n    display: flex;\n    gap: 0.6rem;\n    margin: 0;\n    padding: 1rem 0;\n}\n\n.seller-onboarding-todos__error {\n    align-items: flex-start;\n    flex-direction: column;\n}\n\n.seller-onboarding-todos__error p {\n    color: var(--color-danger-text);\n    margin: 0;\n}\n\n.seller-onboarding-todos__error button {\n    background: var(--color-accent);\n    border: 0;\n    color: #fff;\n    cursor: pointer;\n    font: inherit;\n    font-weight: 700;\n    padding: 0.6rem 0.9rem;\n}\n\n@media (max-width: 650px) {\n    .seller-onboarding-todos__intro {\n        align-items: flex-start;\n        flex-direction: column;\n    }\n\n    .seller-onboarding-todo {\n        align-items: start;\n        grid-template-columns: auto minmax(0, 1fr);\n    }\n\n    .seller-onboarding-todo__actions {\n        align-items: flex-start;\n        grid-column: 2;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .seller-onboarding-todos__progress-track span {\n        transition: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
